<template>
  <b-toast
    toast-class="no-shadow"
    static
    solid
    no-auto-hide
    no-close-button
    visible
    :variant="variant"
  >
    <template #toast-title>
      <notification-title
        :notification="notification"
      ></notification-title>
    </template>
    <notification-content
      :notification="notification"
    ></notification-content>
  </b-toast>
</template>

<script>
import NotificationTitle from './NotificationTitle'
import NotificationContent from './NotificationContent'

export default {
  components: {
    NotificationTitle,
    NotificationContent
  },
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  computed: {
    variant () {
      return 'default'
    }
  }
}
</script>